import { ReduxState } from 'app/redux/types';

import { selectAccountBalance } from 'app/lib/account/selectors';
import { selectIsLoggedIn } from 'app/redux/selectors/auth';

import { StakeErrorCode } from '../constants';
import { OneClickBetState, PresetWithDisplayType } from '../types/oneClickBet';
import { selectOneClickBetState } from './state';

// ---

export const selectProcessingEntry = (state: ReduxState): OneClickBetState['processingEntry'] => {
  return selectOneClickBetState(state).processingEntry;
};

export const selectOneClickBetAmount = (state: ReduxState): PresetWithDisplayType => {
  return selectOneClickBetState(state).amount;
};

export const selectHasOneClickBetEnoughMoney = (state: ReduxState): boolean => {
  if (!selectIsLoggedIn(state)) {
    // Пусть пользователь вводит любую сумму, пока он не авторизован
    return true;
  }

  const entry = selectProcessingEntry(state);

  if (entry?.betInfo.error?.code === StakeErrorCode.NOT_ENOUGH_MONEY) {
    return false;
  }

  const total = selectOneClickBetAmount(state).value;
  const balance = selectAccountBalance(state);

  if (!balance || Number.isNaN(total)) {
    return false;
  }

  return (total <= balance);
};
